//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import useRemoveCustomerDialog from "./useRemoveCustomerDialog";
import { useNavigationHistory } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useRemoveCustomerAction(customerId: number, canRemove: boolean, onSubmitSuccess?: () => void) {
  const { goBack } = useNavigationHistory();
  const removeCustomerDialog = useRemoveCustomerDialog();

  const onUpdateCustomerSubmitSuccess = (): any => {
    goBack();
  };

  const removeCustomerMoreAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.RemoveCustomer),
    icon: IconDefinitionConstants.WTrashAlt,
    highlightType: StyleEnums.DisplayType.Danger,
    actionDialog: removeCustomerDialog(customerId, onUpdateCustomerSubmitSuccess),
    hidden: !canRemove,
  };

  return { removeCustomerMoreAction };
}

export default useRemoveCustomerAction;
